import React, { useState, useEffect } from 'react';
import Modal from 'src/components/common/modal/Modal';
import { UploadButton, Title, TextModal } from '../styles';
import { SummaryWrapper, ButtonsWrapper } from './styles';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import Loading from 'src/components/common/Loading/Loading';
import { useAppDispatch } from 'src/hooks/redux';
import { postAnalogGalleries } from 'src/redux/analog_inventory/thunks';

const ImageUploader = ({ setFieldValue, setNewGallery, newGallery }) => {
    const dispatch = useAppDispatch();
    const [nameGallery, setNameGallery] = useState('');
    const [errorGallery, setErrorGallery] = useState({
        name: '',
        images: '',
    });
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showModalForm, setShowModalForm] = useState(false);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showMessage, setShowMessage] = useState('');
    const [idGallery, setIdGallery] = useState('');

    const validate = (file: File, id: number): boolean => {
        let isValid = true;
        const fileExtension = file.name.split('.').pop()?.toLowerCase();

        // Validar el tipo de archivo
        if (!fileExtension || !['jpg', 'jpeg', 'png'].includes(fileExtension)) {
            isValid = false;
            setErrors([...errors, { id, label: `El archivo ${file.name} no es un formato de imagen válido.` }]);
        }
        return isValid;
    };

    const handleFileChange = (event) => {
        event.preventDefault();
        const files = Array.from(event.target.files || event.dataTransfer.files);
        const newGallery = [...selectedFiles, ...files];
        setSelectedFiles(newGallery);
        if (newGallery.length < 3) {
            setErrorGallery({ ...errorGallery, images: 'Debe subir mínimo tres imágenes' });
        } else {
            setErrorGallery({ ...errorGallery, images: '' });
        }
    };

    const handleSubmit = () => {
        if (!nameGallery) {
            setErrorGallery({ name: 'Debe tener un nombre', images: '' });
            return;
        }
        if (selectedFiles.length < 3) {
            setErrorGallery({ name: '', images: 'Debe subir mínimo tres imágenes' });
            return;
        }
        setLoading(true);
        let images = 0;
        selectedFiles.forEach((file, index) => {
            const isValid = validate(file, index);
            if (isValid) {
                dispatch(postAnalogGalleries({ image: file, name: nameGallery })).unwrap()
                    .then((res) => {
                        setIdGallery(res.data?.gallery_id);
                        if (images === selectedFiles.length) {
                            setLoading(false);
                            setShowMessage(`Se ha creado la galería ${nameGallery}`);
                        }
                    })
                    .catch((error) => {
                        console.error('Error al subir las imágenes:', error);
                        if (images === selectedFiles.length) {
                            setLoading(false);
                            setShowMessage('Error al subir las imágenes');
                        }

                    });
            }
            images = images + 1;
        });
    };

    const handleCloseForm = () => {
        setShowModalForm(false);
        setShowMessage('');
        setTimeout(() => {
            setNewGallery(newGallery + 1);
            setFieldValue('gallery_id', idGallery);
        }, 100)
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleCancel = () => {
        setShowModalForm(false);
        setSelectedFiles([]);
    }

    useEffect(() => {
        if (selectedFiles.length > 0) {
            setShowModalForm(true);
        }
    }, [selectedFiles]);

    return (
        <div>
            <UploadButton className="images" onDrop={handleFileChange} onDragOver={handleDragOver}>
                <label htmlFor="images" className={`drop-container `}>
                    <span className="drop-title">Subir ó arrastrar imagenes</span>
                    <input type="file" id="images" name="images" onChange={handleFileChange} multiple accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG" />
                </label>
            </UploadButton>
            {showModalForm ? (
                <Modal onClose={() => setShowModalForm(false)}>
                    <Title>Nueva galería</Title>
                    {!showMessage ? (
                        <div style={{ marginTop: '32px' }}>
                            <TextField
                                dataId="name-gallery"
                                name="name-gallery"
                                label="Nombre de galería"
                                originType="pcom"
                                placeHolder="Ingrese el nombre de la galería (Obligatorio)"
                                innerLabel
                                value={nameGallery}
                                onChange={(_, value) => setNameGallery(value)}
                                error={Boolean(errorGallery.name)}
                                errorMessage={errorGallery.name}
                            />
                            <SummaryWrapper>
                                <p className="title">Imágenes a subir</p>
                                {selectedFiles.map(({ name }) => (
                                    <p key={name} className="item">
                                        * {name}
                                    </p>
                                ))}
                            </SummaryWrapper>
                            <UploadButton className="images modal" onDrop={handleFileChange} onDragOver={handleDragOver}>
                                <label htmlFor="images" className={`drop-container `}>
                                    <span className="drop-title">Subir o arrastrar más imágenes</span>
                                    <input
                                        type="file"
                                        id="images"
                                        name="images"
                                        onChange={handleFileChange}
                                        multiple
                                        accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                                    />
                                </label>
                                {errorGallery.images ? <div className="error-text">* {errorGallery.images} </div> : ''}
                            </UploadButton>
                            <ButtonsWrapper>
                                <Button
                                    dataId="button-cancel-gallery"
                                    onClick={handleCancel}
                                    originType="pcom"
                                    size="large"
                                    variant="white"
                                    fluid
                                    disabled={loading}
                                >
                                    cancelar
                                </Button>
                                {!loading ? (
                                    <Button dataId="button-create-gallery" onClick={() => handleSubmit()} originType="pcom" size="large" fluid>
                                        Crear galería
                                    </Button>
                                ) : (
                                    <Loading className="loader-button" />
                                )}
                            </ButtonsWrapper>
                        </div>
                    ) : (
                        <div style={{ margin: '40px' }}>
                            <TextModal>{showMessage}</TextModal>
                            <ButtonsWrapper>
                                <Button dataId="button-create-gallery" onClick={handleCloseForm} originType="pcom" size="large">
                                    Aceptar
                                </Button>
                            </ButtonsWrapper>
                        </div>
                    )}
                </Modal>
            ) : null}
        </div>
    );
};

export default ImageUploader;
